import { apiSlice } from "../../app/api/apiSlice";

export const chatSessionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getChatSessions: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/chat_sessions/detailed/",
        params,
      }),
      providesTags: ["ChatSession"],
    }),
    fetchChatSessionById: builder.query({
      query: (id) => `/api/v1/resources/chat_sessions/${id}/`,
      providesTags: (result, error, id) => [{ type: "ChatSession", id }],
    }),
    createChatSession: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/chat_sessions/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["ChatSession"],
    }),
    deleteChatSession: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/chat_sessions/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ChatSession"],
    }),
    uploadWebcamCapture: builder.mutation({
      query: ({ sessionId, s3_key, timestamp }) => ({
        url: `/api/v1/resources/chat_sessions/${sessionId}/webcam_capture/`,
        method: "POST",
        body: { s3_key, timestamp },
      }),
    }),
    getAvData: builder.query({
      query: (sessionId) => `/api/v1/resources/chat_sessions/${sessionId}/av_data/`,
      keepUnusedDataFor: 0,
    }),
    reviewIdentity: builder.mutation({
      query: ({ sessionId, status, flag_reason }) => ({
        url: `/api/v1/resources/chat_sessions/${sessionId}/review_identity/`,
        method: "POST",
        body: { status, flag_reason },
      }),
      invalidatesTags: ["ChatSession"],
    }),
  }),
});

export const {
  useGetChatSessionsQuery,
  useFetchChatSessionByIdQuery,
  useCreateChatSessionMutation,
  useDeleteChatSessionMutation,
  useUploadWebcamCaptureMutation,
  useGetAvDataQuery,
  useReviewIdentityMutation,
} = chatSessionsApiSlice;
